import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class ScriptLoaderService {

  scripts = [
    `https://maps.googleapis.com/maps/api/js?key=${ environment.mapKey }&libraries=places&language=en`
  ];

  private static loadScript(src: string) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;

    document.body.appendChild(script);
  }

  loadScript(): Promise<any> {
    return new Promise<any>((resolve, reject) => {

      this.scripts.forEach(src => {
        ScriptLoaderService.loadScript(src);
      });

      resolve(null);
    });
  }
}
